<section class="pn-pdf">
  <header class="pn-pdf__header" id="pdf-header">
    <div class="pn-pdf__header-top">
      <div class="pn-pdf__header-left">
        <img class="pn-pdf__logo" [src]="logoSrc" alt="Logo INDAP" />
      </div>
      <div class="pn-pdf__header-right">
        <div class="pn-pdf__header-right-line">Plataforma Programa SAT</div>
        <div class="pn-pdf__header-right-line">Gestión de Asesorías Técnicas</div>
      </div>
    </div>
  </header>

  <main class="pn-pdf__content">
    <div id="pdf-section-header">
      <div class="pn-pdf__header-title">Margen Bruto</div>

      <div class="pn-pdf__datos">
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Productor:</span>
          <span class="pn-pdf__dato-value">{{ meta?.productor || estructura?.productor || estructura?.caracterizacion?.productor || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">RUT:</span>
          <span class="pn-pdf__dato-value">{{ meta?.rut || estructura?.rut || estructura?.caracterizacion?.rut || '-' }}</span>
        </div>
        <div class="pn-pdf__dato">
          <span class="pn-pdf__dato-label">Unidad Operativa:</span>
          <span class="pn-pdf__dato-value">{{ meta?.unidad_operativa || estructura?.unidad_operativa || estructura?.caracterizacion?.unidad_operativa || '-' }}</span>
        </div>
        <div class="pn-pdf__dato" *ngIf="versionPdf">
          <span class="pn-pdf__dato-label">Versión:</span>
          <span class="pn-pdf__dato-value">{{ versionPdf }}</span>
        </div>
      </div>
    </div>

<ng-container *ngFor="let grupo of grupos; let i = index; trackBy: trackByGrupo">
 <section [attr.id]="'pdf-section-grupo-' + i "
  class="pn-pdf__section"
  >

  <!-- título del grupo -->
  <h2 class="pn-pdf__h2" >
    {{ grupo.tituloVisible }}
  </h2>

  <!-- tabla principal del grupo -->
  <div class="mb-pdf__tabla-wrap" [attr.id]="'pdf-section-grupo-' + i + '-tabla'">
    <table class="pn-pdf__table pn-pdf__table--boxed mb-pdf__table-completa">
      <thead>
        <tr>
          <th style="width: 60%;">Pregunta</th>
          <th style="width: 40%;">Valor / Respuesta</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fila of grupo.filas; trackBy: trackByFila">
          <td class="mb-pdf__cell-pregunta">{{ fila.pregunta || '-' }}</td>
          <td class="mb-pdf__cell-valor">
            <ng-container *ngIf="fila.respuestaModo === 'bullets' && fila.respuestaItems?.length; else textoRespuesta">
              <ul class="mb-pdf__bullets">
                <li *ngFor="let item of fila.respuestaItems">{{ item }}</li>
              </ul>
            </ng-container>
            <ng-template #textoRespuesta>{{ fila.respuestaTexto ?? '—' }}</ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<section [attr.id]="'pdf-section-grupo-' + i + '-sub-' + j "
  class="pn-pdf__section"
*ngFor="let sub of grupo.subgrupos; let j = index; trackBy: trackBySubGrupo"
>
  <!-- subgrupos -->
  <div >
    <h2 class="pn-pdf__h2" >
      {{ sub.tituloVisible }}
    </h2>
    <div class="mb-pdf__tabla-wrap" [attr.id]="'pdf-section-grupo-' + i + '-sub-' + j + '-tabla'">
      <table class="pn-pdf__table pn-pdf__table--boxed mb-pdf__table-completa">
        <thead>
          <tr>
            <th style="width: 60%;">Pregunta</th>
            <th style="width: 40%;">Valor / Respuesta</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fila of sub.filas; trackBy: trackByFila">
            <td class="mb-pdf__cell-pregunta">{{ fila.pregunta || '-' }}</td>
            <td class="mb-pdf__cell-valor">
              <ng-container *ngIf="fila.respuestaModo === 'bullets' && fila.respuestaItems?.length; else textoRespuestaSub">
                <ul class="mb-pdf__bullets">
                  <li *ngFor="let item of fila.respuestaItems">{{ item }}</li>
                </ul>
              </ng-container>
              <ng-template #textoRespuestaSub>{{ fila.respuestaTexto ?? '—' }}</ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
</ng-container>

    <footer class="pn-pdf__footer" id="pdf-footer">
      Descargado el {{ ahora }}
    </footer>
  </main>
</section>
